import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const RedirectToTab = () => {
  const { navigation } = useNavigation()

  const to = navigation.settings.compensations.fullPath()

  return <Navigate to={to} />
}

export default RedirectToTab
